<template>
  <div class="textdetail">
    <div class="bread_crumb">
      <div class="container_wrap">
        <div class="bread_now_dest">
          当前位置：
          <div
            class="bread_now_dest_item bread_now_dest_item_active"
            v-for="(item, index) in breadData"
            :key="index"
            v-rblink="{ name: 'Cate', query: { id: 'course-' + item.cate_id } }"
          >
            {{ item.name }}&nbsp;&nbsp;>&nbsp;
          </div>
          <div class="bread_now_dest_item">{{ courseSelfData.title }}</div>
        </div>
      </div>
    </div>
    <div class="video_content">
      <div class="container_wrap">
        <div class="title_line">
          <div class="title_line_left">
            <div class="title_line_left_free">免费</div>
            <div class="title_line_left_name">{{ courseSelfData.title }}</div>
          </div>
          <div class="title_line_right">
            <!-- <div class="bshare-custom">
                <a title="分享到微信" class="bshare-weixin"></a
                ><a title="分享到复制网址" class="bshare-clipboard"></a>
                <a title="分享到新浪微博" class="bshare-sinaminiblog"></a
                ><a title="分享到豆瓣" class="bshare-douban"></a>
                <a title="分享到QQ空间" class="bshare-qzone"></a
                ><a
                  title="更多平台"
                  class="bshare-more bshare-more-icon more-style-addthis"
                ></a>
                <span class="BSHARE_COUNT bshare-share-count">{{ courseSelfData.views_count?courseSelfData.views_count:0 }}</span>
              </div> -->
            <vshare :vshareConfig="vshareConfig"></vshare>
          </div>
        </div>
        <div class="status_tips">
          <div class="publish_time">
            发布时间 : {{ courseSelfData.create_time | yearForm }}-{{
              courseSelfData.create_time | monthForm
            }}-{{ courseSelfData.create_time | dayForm }}
          </div>
          <div class="study_count">
            学习人数:{{
              courseSelfData.views_count ? courseSelfData.views_count : 0
            }}
          </div>
        </div>
        <div
          class="video_show"
          :class="leftShowFlag == 1 ? 'video_show_html' : 'video_show_video'"
        >
          <template v-if="leftShowFlag == 1">
            <div
              class="video_show_left html-data"
              v-html="targetHtml"
              v-if="targetHtml"
              ref="html_parent_ref"
              @scroll="htmlParentScrollFun"
            >
              文本文件展示区域
            </div>
            <img
              src="~@/assets/images/listitem/course_constuct.png"
              style="height: 100%; object-fit: cover"
              v-else
            />
          </template>

          <div class="video_show_left" v-else>
            <video
              preload="auto"
              :src="targetVideo"
              controls="controls"
              height="100%"
              width="100%"
              v-if="targetVideo"
            >
              您的浏览器不支持 video 标签。
            </video>
            <img
              src="~@/assets/images/listitem/course_constuct.png"
              style="height: 100%; object-fit: cover"
              v-else
            />
          </div>

          <div class="video_show_right" ref="video_show_right" id="video_show_right">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              class="eltabs"
            >
              <el-tab-pane label="目录" name="目录">
                <div class="list_content">
                  <!-- 1视频 -->
                  <template
                    v-if="
                      $route.query.content_type &&
                      $route.query.content_type == 2
                    "
                  >
                    <div
                      class="list_item"
                      v-for="(item, index) in courseCharpData"
                      :key="index"
                      @click="chapterClickfun(index, item)"
                      ref="chapterRef"
                    >
                      <div class="list_item_left">
                        <!-- 增加class      list_item_left_dot_isactive     可控制小白点触发-->
                        <div
                          class="list_item_left_dot"
                          :class="
                            index == 0
                              ? 'list_item_left_dot_isactive'
                              : item.class
                          "
                        ></div>
                        <div class="list_item_left_line"></div>
                      </div>
                      <div class="list_item_right">
                        <div class="list_item_right_title">
                          {{ item.title }}&nbsp;
                          {{ item.desc }}
                        </div>
                        <div class="list_item_right_tags">
                          <div class="list_item_right_tags_pic"></div>
                          <!-- <div 
                          class="list_item_right_tags_time"
                          v-if="item.video.length != 0"
                        >
                          12:32
                        </div> -->
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- 2文本 -->
                  <template
                    v-else-if="
                      $route.query.content_type &&
                      $route.query.content_type == 1
                    "
                  >
                    <div
                      class="list_item list_item_text"
                      v-for="(item, index) in courseCharpData"
                      :key="index"
                      @click="chapterClickfun(index, item)"
                      ref="chapterRef"
                    >
                      <div class="list_item_left">
                        <!-- 增加class      list_item_left_dot_isactive     可控制小白点触发-->
                        <div
                          class="list_item_left_dot"
                          :class="
                            index == 0
                              ? 'list_item_left_dot_isactive'
                              : item.class
                          "
                        ></div>
                        <div class="list_item_left_line"></div>
                      </div>
                      <div class="list_item_right">
                        <div class="list_item_right_title">
                          {{ item.title }}&nbsp;
                          {{ item.desc }}
                        </div>
                        <div class="list_item_right_tags">
                          <div class="list_item_right_tags_pic"></div>
                          <!-- <div 
                          class="list_item_right_tags_time"
                          v-if="item.video.length != 0"
                        >
                          12:32
                        </div> -->
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- 视频或者文本  主要是大纲 -->
                  <template v-else>
                    <div
                      class="list_item"
                      v-for="(item, index) in courseCharpData"
                      :key="index"
                      :class="item.video.length == 0 ? 'list_item_text' : ''"
                      @click="chapterClickfun(index, item)"
                      ref="chapterRef"
                      :id="'chapterRef'+index"
                    >
                      <div class="list_item_left">
                        <!-- 增加class      list_item_left_dot_isactive     可控制小白点触发-->
                        <div
                          class="list_item_left_dot"
                          :class="
                            index == 0
                              ? 'list_item_left_dot_isactive'
                              : item.class
                          "
                        ></div>
                        <div class="list_item_left_line"></div>
                      </div>
                      <div class="list_item_right">
                        <div class="list_item_right_title">
                          {{ item.title }}&nbsp;
                          {{ item.desc }}
                        </div>
                        <div class="list_item_right_tags">
                          <div class="list_item_right_tags_pic"></div>
                          <!-- <div 
                          class="list_item_right_tags_time"
                          v-if="item.video.length != 0"
                        >
                          12:32
                        </div> -->
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </el-tab-pane>
              <el-tab-pane label="简介" name="简介">
                <div
                  class="simple_intro html-data"
                  v-html="courseSelfData.content"
                >
                  <!-- {{ courseSelfData.content }} -->
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseContent",
  data() {
    return {
      charpDataIndex: 0,
      courseCharpData: [],
      activeName: "目录",
      // leftShowFlag: this.$route.query.content_type, //1 文本   2视频
      leftShowFlag: 1,
      //复联网址  http://xunleib.zuida360.com/1809/%E5%A4%8D%E4%BB%87%E8%80%85%E8%81%94%E7%9B%9F4[%E9%A2%84%E5%91%8A%E7%89%87].mp4
      targetVideo: "", //video地址
      targetHtml: "", //html描述
      courseSelfData: "", //
      vshareConfig: {
        shareList: ["weixin", "copy", "tsina", "douban", "qzone", "more"],
        common: {
          //此处放置通用设置
          bdText: "bdText",
          bdDesc: "bdDesc",
          bdUrl: "bdUrl",
          bdPic: "bdPic",
        },
        share: [
          {
            //此处放置分享按钮设置
            bdSize: 20,
          },
        ],
        slide: [
          //此处放置浮窗分享设置
          { bdTop: -1000 },
        ],
        image: [
          //此处放置图片分享设置
        ],
        selectShare: [
          //此处放置划词分享设置
        ],
      },
      breadData: [],
    };
  },
  beforeCreate() {
    window._bd_share_main = "";
  },
  mounted() {
    this.getcourseInfo();
    this.getCourseBread();
    this.htmlParentScrollFun = this.debounce(this.handleLeftContentScroll,50);
  },
  methods: {
    debounce(fn, delay) {
      let timer = null;
      return function (params) {
        let context = this;
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(context, args);
        }, delay);
      };
    },
    //根据route.query.content_type  区分2视频还是1文本
    splitVideoOrTextFun() {
      if (!this.$route.query.content_type) {
        return;
      }
      this.courseCharpData.some((item) => {
        if (this.$route.query.content_type == 1) {
          //文本
          if (item.video) {
          }
        } else {
          //2 视频
        }
      });
    },
    htmlParentScrollFun() {
      //元素距离顶部元素的距离
      // console.log(document.getElementById("panelRef1").offsetTop-this.$refs.html_parent_ref.scrollTop-290);

      // console.log(this.$refs.html_parent_ref.scrollTop);
      // console.log(document.getElementById("panelRef" + this.charpDataIndex).offsetTop);


      // while (
      //   document.getElementById("panelRef" + this.charpDataIndex).offsetTop -
      //     this.$refs.html_parent_ref.scrollTop -
      //     290 <
      //   0
      // ) {
      //   if (this.charpDataIndex < this.courseCharpData.length) {
      //     this.charpDataIndex++;
      //   } else {
      //     return;
      //   }
      // }

      // console.log(document.getElementById("panelRef0").offsetParent.offsetTop); //父级距离body顶部280
      // console.log(document.getElementById("panelRef0").scrollTop); //父级距离body顶部280
    },
    handleLeftContentScroll(){
      console.log(123);
      this.courseCharpData.forEach((ele,index)=>{
        if (document.getElementById("panelRef" + index).offsetTop -
          this.$refs.html_parent_ref.scrollTop -
          290<=0) {
          this.charpDataIndex=index;
        }
      })
    },
    // 点击导航栏，滚动条移动到内容所对应的位置
    handleToggle(index) {
      // console.log(this.$refs.html_parent_ref.offsetTop); //父级距离body顶部280
      //   网页被卷去的高   offsetTop
      // console.log(document.getElementById("panelRef" + index).offsetTop);//第一个元素距离顶部的距离290
      // window.scrollTo(0, this.$refs.panelRef[index].offsetTop + 1)
      this.$refs.html_parent_ref.scrollTo({
        left: 0,
        top: document.getElementById("panelRef" + index).offsetTop - 290,
        behavior: "smooth",
      });
      // document.getElementById("panelRef" + index).scrollIntoView({
      //   behavior: "smooth", //平滑滚动，爽，其他还有 instant
      //   block: "center", //元素到页面顶部，其他还有 start end, center
      // });
    },
    //获取面包屑
    getCourseBread() {
      if (!this.$route.query.course_cate_id) {
        return;
      }
      this.$api.get(
        "/api/course/cateBreadPath",
        { cate_id: this.$route.query.course_cate_id },
        (res) => {
          this.breadData = res.data;
        },
        (err) => {
          this.$message({ type: "error", message: err.msg });
        }
      );
    },
    chapterClickfun(index, val, flag = 1) {
      this.courseCharpData[index].class = "list_item_left_dot_isactive";
      var temparr = this.courseCharpData;
      this.courseCharpData = [];
      this.courseCharpData = temparr;
      //根据$route.query.content_type 区分当前是视频还是文本
      if (
        this.$route.query.content_type &&
        this.$route.query.content_type == 1
      ) {
        //文本
        this.leftShowFlag = 1;
        if (flag) {
          //flag=0 点击目录，左侧文章跳动//falg=1  点击目录，左侧文章跳动
          this.handleToggle(index);
        }
      } else if (
        this.$route.query.content_type &&
        this.$route.query.content_type == 2
      ) {
        //视频
        this.leftShowFlag = 2;
        this.targetVideo = val.video.length ? val.video[0].url : "";
      } else {
        if (val.video.length > 0) {
          //视频
          this.leftShowFlag = 2;
          this.targetVideo = val.video[0].url;
        } else {
          this.leftShowFlag = 1;
          if (flag) {
            //flag=0 点击目录，左侧文章跳动//falg=1  点击目录，左侧文章跳动
            this.handleToggle(index);
          } else {
            //控制左侧滑动，右侧目录跳动
            // console.log(this.$refs.video_show_right);
            // console.log(this.$refs.chapterRef[0].offsetTop);
            this.$refs.video_show_right.scrollTo({
              left: 0,
              top: this.$refs.chapterRef[index].offsetTop,
              behavior: "smooth",
            });
            // console.log(document.getElementById('video_show_right'));
            
            // document.getElementById('video_show_right').scrollIntoView({
            //   behavior: "smooth", //平滑滚动，爽，其他还有 instant
            //   block: "start", //元素到页面顶部，其他还有 start end, center
            // });
          }
        }
      }
    },
    //tab点击事件
    handleClick(val) {},
    // http://api.eaechina.net/api/course/detail?id=23
    getcourseInfo() {
      // http://api.eaechina.net/api/course/itemList?course_id=23
      const that = this;
      

      that.$api.get(
        "/api/course/detail",
        {
          id: that.$route.query.id, //23
        },
        (res) => {
          // console.log("resres.....", res);
          that.courseSelfData = res.data;
          that.vshareConfig.common.bdText = res.data.title;
          that.vshareConfig.common.bdDesc = res.data.desc;
          that.vshareConfig.common.bdUrl = window.location.href;
          that.vshareConfig.common.bdPic = res.data.pic_url;

          that.getCourseItem();
          //   console.log("that.courseCharpDatathat.courseCharpData",that.courseCharpData[0].video[0])
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },

    getCourseItem(){
      console.log('getcourseInfo');
      let that = this;
      that.$api.get(
        "/api/course/itemList",
        {
          course_id: that.$route.query.id, //23
        },
        (res) => {
          // this.$message.success("发送成功");
          that.courseCharpData = res.data.list;
          this.courseCharpData.some((item) => {
            item.class = "";
          });
          if (
            this.$route.query.content_type &&
            this.$route.query.content_type == 1
          ) {
            //文本
            that.leftShowFlag = 1;
            that.targetHtml = "";
            if (!this.courseCharpData.length) {
              return;
            }
            that.targetHtml = that.courseSelfData.content;
            console.log('that.courseSelfData.content;',that.courseSelfData.content);
            //初始化时
            that.courseCharpData.some((item, index) => {
              if (item.content) {
                // height:0;visibility: hidden
                that.targetHtml +=
                  "<span id='panelRef" +
                  index +
                  "' style='height:0.1px;visibility: hidden'>" +
                  index +
                  "</span>";
                that.targetHtml += item.content;
              }
            });
          } else if (
            this.$route.query.content_type &&
            this.$route.query.content_type == 2
          ) {
            //视频
            that.leftShowFlag = 2;
            that.targetVideo = "";
            if (!this.courseCharpData.length) {
              return;
            }
            that.targetVideo = that.courseCharpData[0].video.length
              ? that.courseCharpData[0].video[0].url
              : "";
          } else {
            //其他普通跳入
            if (
              that.courseCharpData.length > 0 &&
              that.courseCharpData[0].video.length > 0
            ) {
              that.leftShowFlag = 2;
              that.targetVideo = that.courseCharpData[0].video[0].url;
            } else if (that.courseCharpData.length > 0) {
              that.leftShowFlag = 1;
              // that.targetHtml = that.courseCharpData[0].content;
              //初始化时

              that.targetHtml = that.courseSelfData.content;
              that.courseCharpData.some((item, index) => {
                if (item.content) {
                  // height:0;visibility: hidden
                  that.targetHtml +=
                    "<span id='panelRef" +
                    index +
                    "' style='height:0.1px;visibility: hidden'>" +
                    index +
                    "</span>";
                  that.targetHtml += item.content;
                }
              });
            }
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    }
  },
  watch: {
    charpDataIndex: {
      handler(value) {
        this.chapterClickfun(value, this.courseCharpData[value], 0);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.textdetail {
  height: 980px;
  background: #000000;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
}
.bread_crumb {
  width: 100%;
  height: 42px;
  background: #222222;
  .bread_now_dest {
    font-size: 17px;

    font-weight: 400;
    color: #ababab;
    line-height: 42px;
    margin-left: 25px;
    cursor: default;
    display: flex;
    flex-direction: row;
    .bread_now_dest_item {
    }
    .bread_now_dest_item_active {
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.video_content {
  background: #000000;
  .container_wrap {
    padding-top: 37px;
    .title_line {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 31px;
      align-items: center;
      box-sizing: border-box;
      margin-left: 23px;
      .title_line_left {
        display: flex;
        flex-direction: row;
        .title_line_left_free {
          width: 79px;
          height: 31px;
          line-height: 31px;
          background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
          border-radius: 10px 0px 10px 10px;
          text-align: center;
          font-size: 18px;
          font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
            "\5FAE\8F6F\96C5\9ED1";
          font-weight: 500;
          color: #ffffff;
        }
        .title_line_left_name {
          height: 33px;
          font-size: 24px;

          font-weight: 400;
          color: #dddddd;
          line-height: 33px;
          margin-left: 9px;
        }
      }
    }
    .status_tips {
      height: 20px;
      font-size: 14px;

      font-weight: 400;
      color: #dddddd;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      margin-top: 16px;
      margin-left: 23px;
      .publish_time {
        margin-right: 20px;
      }
    }
    .video_show {
      width: 100%;
      height: 569px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background: #2e2e2e;
      margin: 23px 0 0 0;
      box-sizing: border-box;
      overflow: auto;
      .video_show_left {
        display: flex;
        flex-direction: column;
        width: 800px;
        // background: pink;
        margin: 11px 0 11px 15px;
        box-sizing: border-box;
      }
      .video_show_right {
        overflow: auto;
        width: 408px;
        background: #2e2e2e;

        .list_content {
          padding: 0 0 0 15px;
          box-sizing: border-box;
          overflow: auto;
          .list_item {
            display: flex;
            flex-direction: row;
            margin-top: -4px;
            cursor: pointer;
            &:first-child {
              margin-top: 0px;
            }
            &:last-child {
              .list_item_left {
                .list_item_left_line {
                  display: none;
                }
              }
            }
            .list_item_left {
              display: flex;
              flex-direction: column;
              margin-right: 8px;
              align-items: center;
              padding-top: 4px;
              box-sizing: border-box;
              .list_item_left_dot {
                width: 11px;
                height: 12px;
                background: url("~@/assets/images/listitem/Oval 1 Copy 29@2x.png")
                  no-repeat center center;
                background-size: 100% 100%;
              }
              .list_item_left_dot_isactive {
                width: 11px;
                height: 11px;
                border-radius: 5px;
                background: #9eea6a;
              }
              .list_item_left_line {
                height: 62px;
                width: 1px;
                background: url("~@/assets/images/listitem/Line Copy 2@2x.png")
                  no-repeat center center;
                background-size: 100% 100%;
              }
            }
            .list_item_right {
              .list_item_right_title {
                height: 20px;
                font-size: 14px;

                font-weight: 400;
                color: #ffffff;
                line-height: 20px;
              }
              .list_item_right_tags {
                height: 25px;
                line-height: 25px;
                display: flex;
                flex-direction: row;
                margin-top: 4px;
                .list_item_right_tags_pic {
                  height: 25px;
                  width: 40px;
                  background: url("~@/assets/images/listitem/icon-video@2x.png")
                    no-repeat center center;
                  background-size: 100% 100%;
                }
                .list_item_right_tags_time {
                  line-height: 25px;
                  font-size: 14px;

                  font-weight: 400;
                  color: #ffffff;
                  margin-left: 8px;
                }
              }
            }
          }
          .list_item_text {
            .list_item_right {
              .list_item_right_tags {
                .list_item_right_tags_pic {
                  background: url("~@/assets/images/listitem/icon-text@2x.png")
                    no-repeat center center;
                  background-size: 100% 100%;
                }
              }
            }
          }
        }
        .simple_intro {
          font-size: 14px;

          font-weight: 400;
          color: #ffffff;
          padding-left: 16px;
          box-sizing: border-box;
          font-size: 14px;
          line-height: 20px;
          margin-right: 33px;
        }
      }
    }
    // 动态内容区域
    .video_show_html {
      height: 569px;
      display: flex;
      flex-direction: row;
      background: #2e2e2e;
      box-sizing: border-box;
      margin: 23px 0 0 0;
      overflow: auto;
      .video_show_left {
        width: 800px;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        margin: 11px 0 11px 15px;
        box-sizing: border-box;
        overflow: auto;
      }
      img {
        padding: 11px 0 11px 15px;
        box-sizing: border-box;
        max-width: 800px;
      }
    }
    .video_show_video {
      height: 569px;
      display: flex;
      flex-direction: row;
      border-left: 16px solid #2e2e2e;
      margin: 23px 0 0 0;
      box-sizing: border-box;
      overflow: hidden;
      .video_show_left {
        width: 800px;
        display: flex;
        font-size: 0;
        background: none;
        background-color: none;
        border: none;
        box-sizing: border-box;
        overflow: hidden;
        video {
          display: inline-block;
          border: none;
          background: none;
          background-color: none;
        }
      }
    }
  }
}
/deep/.eltabs >>> .el-tabs__header {
  padding-bottom: 27px;
}
/deep/.eltabs >>> .el-tabs__header >>> .el-tabs__nav-wrap {
  height: 62px;
  line-height: 62px;
}
/deep/.eltabs >>> .el-tabs__header >>> .el-tabs__nav-wrap::after {
  background-color: #818181;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll {
  padding-bottom: 12px;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  text-align: center;
  width: 80px;
  float: none;
  padding: 0;
  left: 20px;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__active-bar {
  background-color: #e02020;
  height: 3px;
  bottom: -1px;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  font-size: 16px;
  color: #5d5d5d;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item:hover {
  color: #ffffff;
}
/deep/.eltabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  font-size: 16px;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// CourseContent.vue?27d35d1e